import { Button } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { UseFormSetError } from 'react-hook-form/dist/types/form';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../../../components';
import { FormFriendly, superstructResolver } from '../../../../form';
import type { CodeFormFields } from './CodeForm.validation';
import { CodeFormValidation } from './CodeForm.validation';

interface Props {
  readonly onSubmit: (
    values: CodeFormFields,
    setError: UseFormSetError<CodeFormFields>
  ) => Promise<void>;
}

export const CodeForm = ({ onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation(['login']);
  const {
    handleSubmit,
    control,
    setError,
    formState: { isSubmitting },
  } = useForm<FormFriendly<CodeFormFields>>({
    resolver: superstructResolver(CodeFormValidation),
    defaultValues: {
      code: '',
    },
  });

  return (
    <form onSubmit={handleSubmit((values) => onSubmit(values, setError))}>
      <FormTextField
        fullWidth
        name="code"
        label={t('login:form.code')}
        control={control}
        t={t}
      />
      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        disabled={isSubmitting}>
        {t('login:form.submit')}
      </Button>
    </form>
  );
};
